import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import api from "../../../../../api";

const NewsEventsSection = () => {
    const [newsEventsData, setNewsEventsData] = useState([]);
    const [sectionTitle, setSectionTitle] = useState('NEWS & EVENTS');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNewsEventsData = async () => {
            try {
                setLoading(true);
                const response = await api.get('/api/sitepages/about-us/library');
                
                // Extract news_events_section from the response
                const newsEventsSection = response.data.groups.find(
                    group => group.news_events_section
                )?.news_events_section;
                
                if (newsEventsSection) {
                    // Set section title from API
                    if (newsEventsSection.heading) {
                        setSectionTitle(newsEventsSection.heading);
                    }
                    
                    if (newsEventsSection.items) {
                        // Transform the API data to match our component structure
                        const transformedData = newsEventsSection.items.map((item, index) => ({
                            id: index + 1,
                            modalId: `news-events-modal${index + 1}`,
                            // Store original image_url
                            image_url: item.image_url || '',
                            day: item.day || '',
                            monthYear: item.monthYear || '',
                            title: item.title || '',
                            shortDesc: item.short_desc || '',
                            fullDesc: item.full_desc || ''
                        }));
                        
                        setNewsEventsData(transformedData);
                    }
                }
            } catch (err) {
                console.error('Error fetching news events data:', err);
            } finally {
                setLoading(false);
            }
        };

        fetchNewsEventsData();
    }, []);

    // Function to get complete image URL - FIXED
    const getImageUrl = (imagePath) => {
        if (!imagePath) {
            console.log('No image path provided');
            return 'https://caredemo.care.edu.in/assets/images/lib3.webp';
        }
        
        console.log('Original image path:', imagePath);
        
        // If it's already a full URL, return it as is
        if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
            console.log('Already full URL, returning:', imagePath);
            return imagePath;
        }
        
        // Try with /public prefix first (common Laravel setup)
        const withPublic = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}/public${imagePath}`;
        console.log('Trying with /public:', withPublic);
        
        // Also try without /public
        const withoutPublic = `${process.env.REACT_APP_API_URL || 'http://localhost:8000'}${imagePath}`;
        console.log('Trying without /public:', withoutPublic);
        
        // Return with /public prefix (most common for Laravel)
        return withPublic;
    };

    const slickSettings = {
        dots: false,
        speed: 500,
        autoplay: false,
        autoplaySpeed: 2500,
        pauseOnHover: true,
        slidesToShow: 3,
        loop: false,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    if (loading) {
        return (
            <section className="shop-area position-relative" id="news">
                <div className="container">
                    <div className="row">
                        <div className="sec-title text-center">
                            <h2>NEWS & EVENTS</h2>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-12 mb-5 text-center">
                            <p>Loading news and events...</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (!newsEventsData || newsEventsData.length === 0) {
        return null;
    }

    return (
        <>
            <section className="shop-area position-relative" id="news">
                <div className="container">
                    <div className="row">
                        <div className="sec-title text-center">
                            <h2>{sectionTitle}</h2>
                        </div>
                    </div>
                    <div className="row d-flex justify-content-center">
                        <div className="col-md-12 mb-5">
                            <Slider {...slickSettings} className="library-news-events-carousel">
                                {newsEventsData.map((item) => {
                                    const imageUrl = getImageUrl(item.image_url);
                                    console.log('Final image URL for carousel:', imageUrl);
                                    
                                    return (
                                        <div key={item.id} className="item">
                                            <div 
                                                className="event-item mb-30 hover-zoomin" 
                                                data-bs-toggle="modal"
                                                data-bs-target={`#${item.modalId}`}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <div className="thumb">
                                                    <img 
                                                        src={imageUrl} 
                                                        alt={item.title}
                                                        onError={(e) => {
                                                            console.error('Image failed to load:', imageUrl);
                                                            e.target.onerror = null;
                                                            e.target.src = 'https://caredemo.care.edu.in/assets/images/lib3.webp';
                                                        }}
                                                        onLoad={() => console.log('Image loaded successfully:', imageUrl)}
                                                    />
                                                </div>
                                                <div className="event-content-lib">
                                                    <div className="date">
                                                        <strong dangerouslySetInnerHTML={{ __html: item.day }} /> {item.monthYear}
                                                    </div>
                                                    <h3 dangerouslySetInnerHTML={{ __html: item.title }} />
                                                    <p dangerouslySetInnerHTML={{ __html: item.shortDesc }} />
                                                    <div className="time">
                                                        <strong>Click here</strong>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </Slider>
                        </div>
                    </div>
                </div>
            </section>

            {newsEventsData.map((item) => {
                const imageUrl = getImageUrl(item.image_url);
                console.log('Final image URL for modal:', imageUrl);
                
                return (
                    <div 
                        key={item.modalId}
                        className="modal fade" 
                        id={item.modalId} 
                        tabIndex="-1" 
                        aria-labelledby={`${item.modalId}-label`}
                        aria-hidden="true"
                    >
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5" id={`${item.modalId}-label`}>Events</h1>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <div className="body-inside">
                                        <div className="row justify-content-center">
                                            <div className="col-lg-6">
                                                <div className="event-item mb-30 hover-zoomin">
                                                    <div className="thumb">
                                                        <img 
                                                            src={imageUrl} 
                                                            alt={item.title}
                                                            onError={(e) => {
                                                                console.error('Modal image failed to load:', imageUrl);
                                                                e.target.onerror = null;
                                                                e.target.src = 'https://caredemo.care.edu.in/assets/images/lib3.webp';
                                                            }}
                                                            onLoad={() => console.log('Modal image loaded successfully:', imageUrl)}
                                                        />
                                                    </div>
                                                    <div className="">
                                                        <div className="date">
                                                            <strong dangerouslySetInnerHTML={{ __html: item.day }} /> {item.monthYear}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 d-flex align-items-center">
                                                <div className="event-item mb-30 hover-zoomin">
                                                    <div className="event-content-lib">
                                                        <h3 dangerouslySetInnerHTML={{ __html: item.title }} />
                                                        <div 
                                                            style={{ whiteSpace: 'pre-wrap' }}
                                                            dangerouslySetInnerHTML={{ __html: item.fullDesc }}
                                                        />
                                                        <div className="time"><strong>Events</strong></div>
                                                        <div>
                                                            <strong>
                                                                <a href="#" style={{ textDecoration: 'underline' }}>
                                                                    Click here to register
                                                                </a>
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export default NewsEventsSection;